<template>
  <div>
    <p>
      <strong>{{ $t('contract.working_conditions.headline') }}</strong>
    </p>

    <div>
      <div class="square">
        <span v-show="conditions.shift" class="fa fa-check"></span>
      </div>
      {{ $t('contract.working_conditions.shift.label') }}
    </div>

    <div>
      <div class="square">
        <span v-show="conditions.inconvenient" class="fa fa-check"></span>
      </div>
      <span class="user-output">
        {{ $t('contract.working_conditions.inconvenient.label') }}
      </span>
    </div>

    <p class="mt-2">{{ $t('contract.working_conditions.paragraphs.first') }}</p>
    <hr>
  </div>
</template>

<script>
export default {
  computed: {
    conditions() {
      return this.$store.state.contract.workingConditions;
    },
  },
};
</script>